// ResetListStyle.js
'use strict';
import { css } from 'styled-components';

export const ResetListStyle = css`
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
  list-style: none;
  text-indent: 0;
  list-style-type: 0;
`;

export default ResetListStyle;
